import audioTranslationService from "../services/audioTranslationService";
import { LogFirebase } from "../services/firestore";
import CustomToast from "../components/UI/customToast";
import Localize from "../locale/Localize";
import { PublicVariables } from "../constants/PublicVariables";
import {
    setSourceLanguage,
    setTargetLanguage,
    setTargetLanguageCode,
    setLanguageDrawerOpen,
    clearTranslationError,
} from "../reducers/audioTranslation-reducer";

const getLocalizedValue = (key) => Localize[PublicVariables.currentLanguageObj.languageCode]?.[key];

/**
 * Start translation with the selected languages.
 * Called after user confirms language selection in the drawer.
 */
export const startAudioTranslation = (sourceLanguageCode, targetLanguageCode, targetShortCode) => (dispatch) => {
    dispatch(setSourceLanguage(sourceLanguageCode));
    dispatch(setTargetLanguage(targetLanguageCode));
    dispatch(setTargetLanguageCode(targetShortCode));
    dispatch(clearTranslationError());
    dispatch(setLanguageDrawerOpen(false));

    LogFirebase("AudioTranslation", "user_started_translation", `source:${sourceLanguageCode}_target:${targetLanguageCode}`);

    CustomToast.success(getLocalizedValue("translation_started") || "Audio translation started.");
    audioTranslationService.startTranslation();
};

/**
 * Stop translation.
 */
export const stopAudioTranslation = () => (dispatch) => {
    LogFirebase("AudioTranslation", "user_stopped_translation", "true");
    audioTranslationService.stopTranslation();
    CustomToast.info(getLocalizedValue("translation_stopped") || "Audio translation stopped.");
};

/**
 * Toggle translation on/off from the button.
 * If turning on: open language drawer. If turning off: stop immediately.
 */
export const toggleAudioTranslation = () => (dispatch, getState) => {
    const { translationEnabled } = getState().audioTranslation;
    if (translationEnabled) {
        dispatch(stopAudioTranslation());
    } else {
        dispatch(setLanguageDrawerOpen(true));
    }
};
